/*

---- 加载提示框 ----
this.$loading({
	// title: '提示',
	message: '内容',
	// btn: '确定',
}).then(()=>{
	console.log('点击了确定')
})

*/

import Vue from 'vue'
import loading from './loading.vue'

let loadingControl = Vue.extend(loading)
let loadingDom = new loadingControl({
	el: document.createElement('div'),
})
document.body.appendChild(loadingDom.$el)

let loadingOption = {
	title: '正在加载中，请耐心等待...',
	message: '',
	// btn: '我知道了',
	btn: '',
}

let loadingModal = (o,resolve_fun) => {
	return new Promise((resolve, reject) => {
		let option = Object.assign({},loadingOption,o)
		option.resolve = (resolve_fun?resolve_fun:resolve)
		option.reject = null

		option.btnCall = ()=>{
			option.resolve()
		}

		loadingDom.has = true
		loadingDom.option = option
	})
}

let loadingCloseModal = ()=>{
	loadingDom.has = false
}

export default {
	loadingModal,
	loadingCloseModal,
}


// WEBPACK FOOTER //
// ./src/components/loading/loading.js